import { h } from 'preact';
import PropTypes from 'prop-types';

import './Toggle.scss';

/**
 * iOS Style Pure CSS Toggles
 * @link https://www.cssscript.com/ios-7-style-switches-with-pure-css-css3/
 */
function Toggle(props) {
  return (
    <div className="ios-switch-group">
      <input type="checkbox" name={props.name} id={props.name} className="ios-switch" {...props} />
      <label htmlFor={props.name} className="ios-switch-label">{props.children}</label>
    </div>
  );
}

Toggle.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Toggle;
